import type { RetryOptions } from "@reduxjs/toolkit/query"
import { AxiosError } from "axios"

const ENTRY_RETRY_DELAYS_MS = [1000, 2000, 4000]

/** Entry-critical GETs retry network errors and 5xx up to the ladder's length; a 4xx fails fast. */
export const shouldRetryEntryCritical = (
  error: unknown,
  attempt: number
): boolean => {
  if (attempt > ENTRY_RETRY_DELAYS_MS.length) return false
  const status = (error as AxiosError).response?.status
  return status === undefined || status >= 500
}

export const entryCriticalRetry = {
  backoff: async (attempt: number, _maxRetries: number) => {
    const delay = ENTRY_RETRY_DELAYS_MS[attempt - 1] ?? 4000
    await new Promise<void>((resolve) => setTimeout(resolve, delay))
  },
  retryCondition: (
    error: unknown,
    _args: unknown,
    extraArgs: { attempt: number }
  ): boolean => shouldRetryEntryCritical(error, extraArgs.attempt)
} satisfies RetryOptions
